import { createClient } from '@sanity/client';

const client = createClient({
  projectId: 'xazjl9sh',
  dataset: 'production', 
  useCdn: true,
});

export default client;
